import RecordTemplates                                                  from "../../../../domain/record/template/RecordTemplates";
import { ACTION_TYPE, RecordTemplatesAction, SetRecordTemplatesAction } from "./RecordTemplatesAction";

const reduceRecordTemplates = (action: SetRecordTemplatesAction): RecordTemplates => action.templates;

const recordTemplatesReducer = (state: RecordTemplates = new RecordTemplates(), action: RecordTemplatesAction): RecordTemplates => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_RECORD_TEMPLATES:
      return reduceRecordTemplates(action as SetRecordTemplatesAction);
  }
};

export default recordTemplatesReducer;
